<template>
  <div class="search__container">
    <div class="search__bar">
      <div class="search__bar--content">
        <label class="search__bar--label" for="search_input">
          <Icon icon="search" />
        </label>
        <input aria-disabled="true" class="search__bar--input p4" id="search_input" v-model="message" placeholder="Search Brooklinen" />
        <button class="search__bar--close" @click="closeSearch()">
          <Icon icon="close" />
        </button>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, watch } from 'vue';
import Icon from '../Global/Icon.vue';

const predictiveSearch = document.querySelector('predictive-search');
const shopifyRoutes = window.Shopify.routes.root;
const message = ref('');

const clearSearchResults = () => {
  document.querySelector('.js-search-bar-results').classList.add('hidden');
  document.querySelector('.js-search-bar-results').innerHTML = '';
  document.querySelector('#search_input').value = '';
};

const closeSearch = () => {
  clearSearchResults();
  predictiveSearch.toggle();
};

const performSearch = async (text) => {
  await fetchSearch(text, true);
  fetchSearch(text);
};

const fetchSearch = async (text, productLoad = false) => {
  let queryParams = productLoad ? `&resources[type]=product&resources[options][unavailable_products]=hide&resources[options][fields]=title,product_type,variants.title` : '';
  let url = `${shopifyRoutes}search/suggest?q=${text}${queryParams}&resources[limit]=4&section_id=predictive-search`;

  const response = await fetch(url),
    json = await response.text(),
    parsedText = new DOMParser().parseFromString(json, 'text/html'),
    results = parsedText.querySelector('#shopify-section-predictive-search');

  const searchListProducts = results.querySelector('.search__list--product'),
    searchListViewAll = results.querySelector('.search__list--view-all');

  const searchResultsEl = document.querySelector('.js-search-bar-results'),
    searchListEl = searchResultsEl.querySelectorAll('.search__list--results'),
    searchListLength = searchListEl.length;

  if (productLoad && searchListLength == 0) searchResultsEl.innerHTML = results.innerHTML;
  else {
    // remove duplicate product and view all results
    if (!!searchListProducts) searchListProducts.parentNode.removeChild(searchListProducts);
    if (!!searchListViewAll) searchListViewAll.parentNode.removeChild(searchListViewAll);

    // prepend new view all element
    const searchListResults = results.querySelector('.Search__List--Results');
    if (!!searchListResults && (searchListLength == 2 || searchListLength == 1)) {
      const newLink = `${shopifyRoutes}search?q=${text}`;
      searchResultsEl.querySelector('.search__list--view-all').href = newLink;
      searchResultsEl.querySelector('.search__list--view-all').before(searchListResults);
    }

    searchResultsEl.classList.remove('hidden');
    return productLoad;
  }
};

watch(message, (text) => {
  clearSearchResults();
  if (text.length > 2) performSearch(text);
}),
  onMounted(() => {
    document.querySelector('.search__bar--input').focus();

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') closeSearch();
      else if (e.key === 'Enter') {
        if (e.target.className === 'search__bar--close') {
          e.preventDefault();
          closeSearch();
        } else if (message.value.length > 2) location.assign(`/search?q=${message.value}`);
      } else if (e.code == 'Tab') {
        const linkElems = Array.from(document.querySelectorAll('.search__list--content .link'));
        const lastElem = linkElems.slice(-1)[0];
        const firstElem = linkElems[0];
        if (e.shiftKey) {
          if (document.activeElement === firstElem) {
            // Shift + Tab
            lastElem.focus();
            e.preventDefault();
          }
        } else if (document.activeElement === lastElem) {
          firstElem.focus();
          e.preventDefault();
        }
      }
    });

    document.querySelector('.predictive-search--overlay').addEventListener('click', (e) => {
      closeSearch();
    });
  });
</script>
